<template>
  <div class="wrap_xszn">
    <v-tabs :menus="menus" />
    <div class="cjwt-main">
      <router-view/>
    </div><!--xszn_main-->
  </div>
</template>
<script>
import vTabs from '../../components/tabs.vue';

export default {
  name: 'cjwt',
  components: {
    vTabs,
  },
  data() {
    return {
      menus: [
        { name: '通用问题', path: '/cjwt/tywt', className: 'czzn-tbs-cssz' },
        { name: '功能操作', path: '/cjwt/gncz', className: 'czzn-tbs-zbcx' },
        { name: '其他问题', path: '/cjwt/qtwt', className: 'czzn-tbs-nssb' },
      ],
    };
  },
};
</script>
